import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// PrimeNG Components
import { ListboxModule } from 'primeng/listbox';
import { MessageModule } from 'primeng/message';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from "primeng/dialog";
import {CheckboxModule} from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
// Module
import { AuthRoutingModule } from './auth-routing.module';
import { ComponentsModule } from '../components/components.module';

// Application Components
import { LoginComponent } from './login/login.component';
import { LogoutComponent} from './logout/logout.component';
import { ChangePassComponent } from './change-pass/change-pass.component';
import { ResetPassComponent } from './reset-pass/reset-pass.component';
import { RegistroComponent } from './registro/registro.component';
import { SolicitarConfirmacionComponent } from './solicitar-confirmacion/solicitar-confirmacion.component';
import { ConfirmUserComponent } from './confirm-user/confirm-user.component';
import { MigrationUserComponent } from './migration-user/migration-user.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent,
    ChangePassComponent,
    RegistroComponent,
    SolicitarConfirmacionComponent,
    ConfirmUserComponent,
    ResetPassComponent,
    MigrationUserComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    ComponentsModule,
    ReactiveFormsModule,
    ListboxModule,
    MessageModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    FileUploadModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    DialogModule,
    CheckboxModule,
    FormsModule,
    RadioButtonModule,
    DropdownModule,
  ]
})
export class AuthModule { }
